__turbopack_context__.v({
  "similarListingsSection": "similar-listings-section-module-scss-module__j8egxG__similarListingsSection",
});
